import React from "react";
import { createBrowserRouter, Navigate, RouterProvider, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import Login from "./pages/Login";
import NewBuilding from "./pages/NewBuilding";
import NewContributor from "./pages/NewContributor";
import ListImoveis from "./pages/ListImoveis";
import CalcularImposto from "./pages/CalcularImposto";
import CancelCharger from "./pages/CancelCharger";
import ListChargers from "./pages/ListChargers";
import PayCharger from "./pages/PayCharger";
import ListPayments from "./pages/ListPayments";
import GerarCobrancaAleatoria from "./pages/GerarCobrancaAleatoria";
import GerarCobrancaMassiva from "./pages/GerarCobrancaMassiva";
import ManagerStreets from "./pages/ManagerStreets";

import { hasAnyRole, isAuthenticated, logout } from "./services/auth";
import ContribuintesInad from "./pages/ContribuintesInad";
import TransferirImovel from "./pages/TransferirImovel";
import GovBrCallback from "./pages/GovBrCallback";
import ListContribuintes from "./pages/ListContribuintes";
import LoginAdm from "./pages/LoginAdm";
import ValidarCertidao from "./pages/ValidarCertidao";
import EmitirNadaConsta from "./pages/EmitirNadaConsta";

const PrivateRoute = ({ component: Component, roles }) => {
  const location = useLocation();
  
  if (isAuthenticated()) {
    if (roles && roles.length > 0 && !hasAnyRole(roles)) {
      return <Navigate to='/' />;
    }
    return <Component />;
  } else {
    const fullPath = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(fullPath)}`} />;
  }
};

const RootRoute = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const state = queryParams.get('state');

  if (code && state) {
    return <GovBrCallback />;
  }

  return <PrivateRoute component={Home} />;
};

const Logout = () => {
  React.useEffect(() => {
    logout();

    const postLogoutRedirectUri = process.env.REACT_APP_GOVBR_REDIRECT_URI;
    if (postLogoutRedirectUri && postLogoutRedirectUri.trim()) {
      const url = `${process.env.REACT_APP_GOVBR_ENDPOINT}/logout?post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri.trim())}`;
      window.location.href = url;
      return;
    }

    window.location.href = '/login';
  }, []);

  return null;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootRoute />,
    errorElement: <h3>Descupe, página não encontrada!</h3>
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/login-adm',
    element: <LoginAdm />
  },
  {
    path: '/auth/govbr/callback',
    element: <GovBrCallback />
  },
  {
    path: '/logout',
    element: <Logout />
  },
  {
    path: '/contribuintes',
    element: <PrivateRoute component={ListContribuintes} roles={['ADMIN']} />
  },
  {
    path: '/novo-contribuinte',
    element: <PrivateRoute component={NewContributor} roles={['ADMIN']} />
  },
  {
    path: '/editar-contribuinte/:contribuinteID',
    element: <PrivateRoute component={NewContributor} roles={['ADMIN']} />
  },
  {
    path: '/contribuintes/:contribuinteID/imoveis',
    element: <PrivateRoute component={ListImoveis} roles={['ADMIN']} />
  },
  {
    path: '/contribuintes-inadimplentes',
    element: <PrivateRoute component={ContribuintesInad} roles={['ADMIN']} />
  },
  {
    path: '/contribuintes/:contribuinteID/gerar-cobranca',
    element: <PrivateRoute component={GerarCobrancaAleatoria} roles={['ADMIN']} />
  },  
  {
    path: '/contribuintes/:contribuinteID/imoveis/:imovelID/calcular-imposto',
    element: <PrivateRoute component={CalcularImposto} roles={['ADMIN']} />
  },
  {
    path: '/contribuintes/:contribuinteID/novo-imovel',
    element: <PrivateRoute component={NewBuilding} roles={['ADMIN']} />
  },
  {
    path: '/contribuintes/:contribuinteID/editar-imovel/:imovelID',
    element: <PrivateRoute component={NewBuilding} roles={['ADMIN']} />
  },
  {
    path: '/imoveis',
    element: <PrivateRoute component={ListImoveis} />
  },
  {
    path: '/cobrancas',
    element: <PrivateRoute component={ListChargers} />
  },
  {
    path: '/gerar-iptu-massivo',
    element: <PrivateRoute component={GerarCobrancaMassiva} roles={['ADMIN']} />
  },
  {
    path: '/cancelar-cobranca',
    element: <PrivateRoute component={CancelCharger} roles={['ADMIN']} />
  },
  {
    path: '/pagar-cobranca',
    element: <PrivateRoute component={PayCharger} roles={['ADMIN']} />
  },
  {
    path: '/pagamentos',
    element: <PrivateRoute component={ListPayments} roles={['ADMIN']} />
  },
  {
    path: '/gerenciar-ruas',
    element: <PrivateRoute component={ManagerStreets} roles={['ADMIN']} />
  },
  {
    path: '/transferir-imovel',
    element: <PrivateRoute component={TransferirImovel} roles={['ADMIN']} />
  },
  {
    path: '/validar-certidao',
    element: <ValidarCertidao />
  },
  {
    path: '/validar-certidao/:codigo',
    element: <ValidarCertidao />
  },
  {
    path: '/emitir-nada-consta/:contribuinteID',
    element: <PrivateRoute component={EmitirNadaConsta} roles={['ADMIN', 'USER']} />
  }
]);

export default function Routes() {
  return (
    <RouterProvider router={router} />
  );
}